import React, {
  useState,
  useEffect,
} from 'react';
import Select from 'react-select';
import { useDispatch } from 'react-redux';

import {
  isEqual,
  get,
  map,
} from 'lodash/fp';

import { useStateBus } from '~/state/bridge';

import { getIsInstagramSelected } from '~/state/AdPlacement/selectors';
import { useInstagramAccountQueries, usePageQuery } from '~/theseus/hooks/queries';

const transformToOptions = (group) => ({
  label: group?.name,
  options: group?.ig?.map(({ username, id: accountId }) => ({
    label: username,
    value: accountId,
  })),
});

function InstagramSelector() {
  const [pageId] = usePageQuery();
  const instagramSelected = useStateBus(getIsInstagramSelected);
  const dispatch = useDispatch();
  const [currentOption, setCurrentOption] = useState(null);

  const accountQueries = useInstagramAccountQueries({
    select: map(transformToOptions),
  });

  const isLoading = accountQueries.map(get('isLoading')).every(isEqual(true));
  const instagramOptions = accountQueries.map(get('data')).flat();

  useEffect(() => {
    setCurrentOption(null);
  }, [pageId, instagramSelected]);

  useEffect(() => {
    dispatch({ type: 'setInstagramAccount', payload: currentOption?.value || null });
  }, [dispatch, currentOption]);

  // TODO: This will need to eventually be managed by a CampaignOptions component
  if (!instagramSelected) return null;

  return (
    <div id="campaign__advanced-instagram" className="campaign__advanced-container">
      <h3>Instagram Account Selection</h3>
      <Select
        id="ig-selector"
        value={currentOption}
        onChange={setCurrentOption}
        options={instagramOptions}
        isLoading={isLoading}
      />
    </div>
  );
}

export default InstagramSelector;
